import ConstructedResponsePromptApi from './ConstructedResponsePromptApi';
export default ConstructedResponsePromptApi;
